<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        btitle="Flow Config"
        style="height: 410px"
      >
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="isShowAddTable = true"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllFlow"
                />
                <label for="idSelectAllFlow"></label>
              </th>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in FlowTable"
              :key="row.profileid"
              :class="{ 'true:': true }"
              @click="changeSelect(row)"
            >
              <td width="40px">
                <div @click.stop="" v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectFlow' + index"
                  />
                  <label :for="'idRowSelectFlow' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.flowId }}</div>
              </td>
              <td>
                <div>{{ row.flowPort }}</div>
              </td>
              <td>
                <div>{{ row.flowEthType | formmatethType }}</div>
              </td>
              <td>
                <div>{{ row.flowAction }}</div>
              </td>
              <td>
                <div>{{ row.flowVlan }}</div>
              </td>
              <td>
                <div>{{ row.flowPri }}</div>
              </td>
              <td>
                <div>{{ row.flowNewVlan }}</div>
              </td>
              <td>
                <div>{{ row.flowNewPri }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Flow Edit'"
            @close="isShowAddTable = false"
            style="min-height: 410px"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="flowId">{{
                  title.flowId
                }}</label>
                <div class="col-sm-5"  :class="{ 'has-error': input_para_check(1)}">
                  <input
                    type="text"
                    class="form-control"
                    id="flowId"
                    :disabled="isEditClik"
                    v-model="flowForm.flowId"
                    autocomplete="off"
                    placeholder="INTEGER<0-63>"
                  />
                   <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Port Type</label>
                <div class="col-sm-5">
                  <label>
                    <input
                      type="radio"
                      class="form-control"
                      value="1"
                      id="flowethport"
                      v-model="flowForm.flowPortType"
                    />
                    <label for="flowethport">Eth</label>
                  </label>
                  <label style="margin-left: 15px">
                    <input
                      type="radio"
                      class="form-control"
                      value="3"
                      id="flowiphost"
                      v-model="flowForm.flowPortType"
                    />
                    <label for="flowiphost">Iphost</label>
                  </label>
                     <label style="margin-left: 15px">
                    <input
                      type="radio"
                      class="form-control"
                      value="2"
                      id="flowveip"
                      v-model="flowForm.flowPortType"
                    />
                    <label for="flowveip">Veip</label>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="flowPort">{{
                  title.flowPort
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                  <input
                    type="text"
                    class="form-control"
                    id="flowPort"
                    :disabled="flowForm.flowPortType != '1'"
                    v-model="flowForm.flowPort"
                    placeholder="INTEGER<1-24>"
                  />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="flowEthType">{{
                  title.flowEthType
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="flowEthType"
                    v-model="flowForm.flowEthType"
                  >
                    <option value="">
                      None
                    </option>
                    <option value="3">arp</option>
                    <option value="1">ipoe</option>
                    <option value="2">pppoe</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="flowAction">{{
                  title.flowAction
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="flowAction"
                    v-model="flowForm.flowAction"
                  >
                    <option value="" disabled selected style="display: none">
                     please choose..
                    </option>
                    <option value="0">Transparent</option>
                    <option value="1">Tag</option>
                    <option value="2">Translation</option>
                    <option value="3">Trunk</option>
                  </select>
                </div>
              </div>

              <div v-if="flowForm.flowAction > '1'" class="form-group">
                <label class="col-sm-3 control-label" for="flowVlan">{{
                  title.flowVlan
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(3)}">
                  <input
                    type="text"
                    class="form-control"
                    id="flowVlan"
                    v-model="flowForm.flowVlan"
                    placeholder="INTEGER<1-4094>"
                  />
                   <small
                        class="help-block"
                        :style="{
                          display: input_para_check(3) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(3) }}
                      </small>
                </div>
              </div>

              <div v-if="flowForm.flowAction > '1'" class="form-group">
                <label class="col-sm-3 control-label" for="flowPri">{{
                  title.flowPri
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="flowPri"
                    v-model="flowForm.flowPri"
                  >
                  <option value="">
                        None
                      </option>
                      <option value="0">0</option>
                      <option v-for=" pri in 7" :key="pri" :value="pri">{{pri}}</option>
                    </select>
                </div>
              </div>

              <div
                v-if="flowForm.flowAction == '1' || flowForm.flowAction == '2'"
                class="form-group"
              >
                <label class="col-sm-3 control-label" for="flowVlan">{{
                  title.flowNewVlan
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(4)}">
                  <input
                    type="text"
                    class="form-control"
                    id="flowVlan"
                    v-model="flowForm.flowNewVlan"
                    placeholder="INTEGER<1-4094>"
                  />
                   <small
                        class="help-block"
                        :style="{
                          display: input_para_check(4) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(4) }}
                      </small>
                </div>
              </div>

              <div
                v-if="flowForm.flowAction == '1' || flowForm.flowAction == '2'"
                class="form-group"
              >
                <label class="col-sm-3 control-label" for="flowNewPri">{{
                  title.flowNewPri
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="flowNewPri"
                    v-model="flowForm.flowNewPri"
                  >
                  <option value="">
                        None
                      </option>
                      <option value="0">0</option>
                      <option v-for=" pri in 7" :key="pri" :value="pri">{{pri}}</option>
                    </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"

export default {
  name: "profileLineFlow",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  props: ["profileId"],

  data() {
    return {
      title: {
        flowId: "Flow Id",
        flowPort: "Flow Port",
        ethtype: "Ethernet Type",
        flowAction: "Flow Action",
        flowvlan: "Flow Vlan",
        flowPri: "Flow Pri",
        newVlan: "New Vlan",
        newPri: "New Pri",
      },
      isShowAddTable: false,
      isEditClik: false,
      iBox: {},
      isSelectAll: false,
      select: [],

      flowForm: {
        flowId: "",
        flowPortType: "1",
        flowPort: "",
        flowEthType: "",
        flowAction: "",
        flowVlan: "",
        flowPri: "",
        flowNewVlan: "",
        flowNewPri: "",
      },

      FlowTable: [],
    }
  },

  created() {
    this.loadFlowInfo()
  },

  watch:{
    'flowForm.flowAction':function(){
        this.flowForm.flowVlan = ""
        this.flowForm.flowPri = ""
        this.flowForm.flowNewVlan = ""
        this.flowForm.flowNewPri = ""
    },

    'flowForm.flowPortType':function(){
        this.flowForm.flowPort = ""
    }
  },

  methods: {
    loadFlowInfo() {
      get("profileflow?profileId=" + this.profileId)
        .then((res) => {
          this.FlowTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        flowId: "",
        flowPortType: "1",
        flowPort: "",
        flowPort: "",
        flowEthType: "",
        flowAction: "",
        flowVlan: "",
        flowPri: "",
        flowNewVlan: "",
        flowNewPri: "",
      }

      this.flowForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.flowId) - Number(b.flowId)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.profileId),
        flowId: Number(this.flowForm.flowId),
        flowPortType: Number(this.flowForm.flowPortType),
        flowPort: Number(this.flowForm.flowPort),
        flowEthType: Number(this.flowForm.flowEthType),
        flowAction: Number(this.flowForm.flowAction),
        flowVlan: Number(this.flowForm.flowVlan),
        flowPri: Number(this.flowForm.flowPri),
        flowNewVlan: Number(this.flowForm.flowNewVlan),
        flowNewPri: Number(this.flowForm.flowNewPri),
        operate: 1,
      }
      var id

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      for (id in this.flowForm) {
        if (this.flowForm[id] == "") newProfile[id] = -1
      }

      if(this.flowForm.flowPortType != '1')
      {
        newProfile.flowPort = -1
      }

      if (!this.isEditClik) {
        for (let i = 0; i < this.FlowTable.length; i++) {
          if (this.FlowTable[i].flowId == newProfile.flowId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this flow id has been existed,please choose a new one"
            )
            return
          }
        }
      }

      post("profileflow", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadFlowInfo()
            /*for (id in newProfile) {
              if (newProfile[id] == -1) newProfile[id] = ""
            }
            if (this.isEditClik) {
              let index = this.select[0]
              this.FlowTable[index]= newProfile
            }
            else {
              this.FlowTable.push(newProfile)
              this.FlowTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.FlowTable.length; i++) {
        if (this.FlowTable[i].selected) {
          this.flowForm.flowId = this.FlowTable[i].flowId
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        flowId: 1,
        operate: 2,
      }

      for (i = 0; i < this.FlowTable.length; i++) {
        if (this.FlowTable[i].selected) {
          newProfile.profileId = Number(this.profileId)
          newProfile.flowId = Number(this.FlowTable[i].flowId)
          del.push(post("profileflow", newProfile))
          id.push(this.FlowTable[i].flowId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.FlowTable.length; i++) {
                if (this.FlowTable[i].flowId == id[index]) {
                  this.FlowTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.FlowTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.FlowTable[i], "selected", true)
        } else {
          this.$set(this.FlowTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

     input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.flowForm.flowId != "")
        {
            let flowId = Number(this.flowForm.flowId)
            if(!isNaN(flowId))
            {
                if(flowId < 0 || flowId > 63)
                return "flow id must be in range 0-63"
            }
            else
              return "flow id must be in range 0-63"
        }
      }

      if(value == 3 || value == 0)
      {
        if(this.flowForm.flowVlan != "")
        {
            let flowvlan = Number(this.flowForm.flowVlan)
            if(!isNaN(flowvlan))
            {
                if(flowvlan < 1 || flowvlan > 4094)
                return "vlan id must be in range 1-4094"
            }
            else
              return "vlan id must be in range 1-4094"
        }
      }

      if(value == 4 || value == 0)
      {
        if(this.flowForm.flowNewVlan != "")
        {
            let flowvlan = Number(this.flowForm.flowNewVlan)
            if(!isNaN(flowvlan))
            {
                if(flowvlan < 1 || flowvlan > 4094)
                return "vlan id must be in range 1-4094"
            }
            else
              return "vlan id must be in range 1-4094"
        }
      }

      if(value == 2 || value == 0)
      {
        if(this.flowForm.flowPort != "")
        {
            let mapPort = Number(this.flowForm.flowPort)
            if(!isNaN(mapPort))
            {
                if(mapPort < 1 || mapPort > 24)
                return "onu port id must be in range 1-24"
            }
            else
              return "onu port id must be in range 1-24"
        }
      }
      return null
    }
  },

  filters: {
    formmatethType: function (value) {
      if (value == "1") return "ipoe"
      else if (value == "2") return "pppoe"
      else if (value == "3") return "arp"
      else return value
    },
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>
